import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import { Layout } from 'tea-component';
import Tabs from '@intelligence/components/NewIconTabs';
import { history, useIntl, useParams } from 'umi';
import '@/pages/intelligence/assets/scss/GlobalView/index.scss';
// import Newzoo from '@/pages/home/assets/svg/dataSource/databarin.svg';
// import Newzoo from '@/pages/intelligence/assets/svg/dataSource/newzoo.svg';
import Newzoo from '@/pages/intelligence/assets/svg/dataSource/databarin-gray.svg';
import SvgIcon from '@/pages/home/components/SvgIcon';
import ByRevenue from './ByRevenue';
import { useUrlQueryParam } from './hooks/useQuery';
import MarqueeBanner from '@intelligence/components/MarqueeBanner/index';
const { Body, Content } = Layout;
interface ITabs {
  id: string;
  label: string | ReactNode;
  component: ReactElement;
}

export default function GlobalView() {
  // 通过路由的变化，来执行fetch回调，触发渲染
  const active = useParams() as any;
  const [{ activeId = active.tab }, setActiveId] = useUrlQueryParam(['activeId']);
  const { formatMessage } = useIntl();

  const tabs: ITabs[] = [
    {
      id: 'revenue',
      label: (
        <div className="dbi-tab-title">
          <SvgIcon className="dbi-tab-title-svg" type="dollar-icon" />
          {formatMessage({ id: 'dbi_global_view_by_revenue' })}
        </div>
      ),
      component: <ByRevenue tab={'revenue'} />,
    },
    {
      id: 'players',
      label: (
        <div className="dbi-tab-title">
          <SvgIcon className="dbi-tab-title-svg" type="user" />
          {formatMessage({ id: 'dbi_global_view_by_Players' })}
        </div>
      ),
      component: <ByRevenue tab={'players'} />,
    },
  ];
  const handleOnClickActive = ({ id }: { id: string; }) => {
    setActiveId({ activeId: id });
    history.replace(`/intelligence/globalView/marketSize/${id}`);
  };

  return (
    <Layout className="dbi-global-view">
      <Body>
        <Content>
          <Content.Header
            className="contentHead-normal"
            title={
              <div className="dbi-global-view-title">
                {formatMessage({ id: 'dbi_global_view_market_header' })}<img src={Newzoo} className="view-title-img" />
              </div>
            }
          >
            <div className="header-tab">
              <Tabs
                ceiling
                newMarkIdsMappingKey="GlobalViewMarketSize"
                tabs={tabs}
                animated={false}
                activeId={activeId}
                onActive={handleOnClickActive}
              />
            </div>
          </Content.Header>
          <Content.Body full>
            <MarqueeBanner />
            {tabs.map((e) => (
              <div key={e.id}>{e.id === activeId ? e.component : ''}</div>
            ))}
          </Content.Body>
        </Content>
      </Body>
    </Layout>
  );
}
